import { GoogleTagManager } from "@next/third-parties/google";
import { canUseGoogleTagManager } from "./googleTagManager";
import { TRACKING_SCRIPT_DELAY_MS, useDelayAfterLoad } from "../utils/useDelayAfterLoad";

/**
 * Loads the Google Tag Manager container a delay after the page has loaded.
 * @param props.delayMs How long to wait after the load event, 0 for pages that navigate away before it passes
 * @returns The container scripts, or nothing in development, without a container id or before the delay has passed
 */
export function GoogleTagManagerScript({ delayMs = TRACKING_SCRIPT_DELAY_MS }: { delayMs?: number }) {
    const gtmId = process.env.NEXT_PUBLIC_GTM_ID;
    const delayElapsed = useDelayAfterLoad(delayMs);

    if (!canUseGoogleTagManager(gtmId) || !delayElapsed) return null;

    return <GoogleTagManager gtmId={gtmId} />;
}
